import { useTranslation } from '../../../contexts/translation-context';
import { ConnectionsPanel } from '../../telemetry/components/ConnectionsPanel';

/**
 * Internal page for the tracking connectors.
 *
 * One page for every provider — FleetMaster is only the first — so nothing here names one. An internal
 * user belongs to no supplier or customer, so every connection they create has to name its owner —
 * hence `requiresOwner`.
 */
export const TrackingSettingsPage = () => {
  const { i18n } = useTranslation();

  return (
    <ConnectionsPanel
      requiresOwner
      title={i18n('liveTracking.connections')}
      subtitle={i18n('liveTracking.connectionsSubtitle')}
    />
  );
};
